export function getTabName(): string {
    return  process.env.TAB_NAME ? process.env.TAB_NAME : "Simpl CRM "
}